// SoundManager.ts
import { Howl } from "howler";
import { soundKeys } from "./emotes/emoteKeys";

type SoundKey = (typeof soundKeys)[number];

class SoundManager {
  private sounds: Record<SoundKey, Howl>;

  constructor() {
    this.sounds = [...soundKeys].reduce(
      (acc, key) => {
        acc[key] = new Howl({ src: [`/assets${key}.mp3`] });
        return acc;
      },
      {} as Record<SoundKey, Howl>,
    );
  }

  playSound(key: SoundKey) {
    const sound = this.sounds[key];
    if (sound) {
      sound.play();
    }
  }
}

const soundManager = new SoundManager();
export default soundManager;
export type { SoundKey };
